import { render, staticRenderFns } from "./system-account-settings.vue?vue&type=template&id=245346b8&scoped=true"
import script from "./system-account-settings.vue?vue&type=script&lang=js"
export * from "./system-account-settings.vue?vue&type=script&lang=js"
import style0 from "./system-account-settings.vue?vue&type=style&index=0&id=245346b8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245346b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('245346b8')) {
      api.createRecord('245346b8', component.options)
    } else {
      api.reload('245346b8', component.options)
    }
    module.hot.accept("./system-account-settings.vue?vue&type=template&id=245346b8&scoped=true", function () {
      api.rerender('245346b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/paycools/system/system-account-settings.vue"
export default component.exports